import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import CountTime from '@/components/common/CountTime';
import TagItem from '@/components/common/TagItem';
import { parseDetailUrl } from "@/utils";
import GroupPurchaseBulletScreen from "@/components/GroupPurchaseBulletScreen/index";

// robType: 1.今日必抢,2.限时优惠 3.本周临演出
export default {
  // 今日必抢
  name: 'today-look',
  components: {
    CountTime: CountTime,
    TagItem: TagItem,
    GroupPurchaseBulletScreen: GroupPurchaseBulletScreen
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    gotoTodayPage: {
      type: Function
    }
  },
  data: function data() {
    return {
      // 单行展示今日必抢项目
      topList: [],
      // 三列展示的必抢项目
      projectList: []
    };
  },
  watch: {
    list: 'initList'
  },
  mounted: function mounted() {
    this.initList();
  },
  methods: {
    initList: function initList() {
      var _this = this;
      var list = this.list;
      if (list && list.length) {
        var todayList = list.map(function (a, index) {
          var reuslt = Object.assign({}, a);
          reuslt.discountText = _this.discountText(a);
          reuslt.timeText = _this.timeText(a);
          reuslt.countTime = _this.countTime(a);
          // 是否是即将开售
          reuslt.preSale = a.ticketStatus === 1;
          try {
            // 曝光打点
            if (index <= 4) {
              window.seedAction({
                bid: a.dataSeed.viewBid,
                evt: 'view',
                custom: a.dataSeed.custom
              });
            }
          } catch (error) {}
          return reuslt;
        });
        var topList = todayList.filter(function (a) {
          return a.reachRobStandard;
        });
        var projectList = todayList.filter(function (a) {
          return !a.reachRobStandard;
        });
        this.topList = topList;
        this.projectList = projectList.slice(0, 12);
        this.$nextTick(function () {
          var scrollEl = document.getElementById('today-scroll-view-stats');
          scrollEl.addEventListener('scroll', window.StatusReportData, false);
        });
      }
    },
    handleClick: function handleClick(project) {
      var _ref = project || {},
        performanceId = _ref.performanceId,
        dataSeed = _ref.dataSeed,
        tagSeed = _ref.tagSeed,
        _ref$jumpDetailUrl = _ref.jumpDetailUrl,
        jumpDetailUrl = _ref$jumpDetailUrl === void 0 ? "" : _ref$jumpDetailUrl;
      if (!performanceId) return;
      if (jumpDetailUrl) {
        this.go(parseDetailUrl(jumpDetailUrl), {
          _blank: true
        });
      } else {
        this.go("/detail/".concat(performanceId), {
          _blank: true
        });
      }
      // this.go(`/detail/${performanceId}`, { _blank: true })
      if (tagSeed) {
        window.lxTagReport('c_movie_aq5xt2v5', dataSeed.bid, Object.assign({}, tagSeed));
      }
      if (dataSeed) {
        window.seedAction(dataSeed);
      }
    },
    // 计算项目的折扣
    discountText: function discountText(content) {
      if (!content) return '';
      var robType = content.robType;
      var _ref2 = content.projectExtendVO || {},
        maxDiscSingleValue = _ref2.maxDiscSingleValue,
        maxDiscSetValue = _ref2.maxDiscSetValue;
      if (robType !== 2) return '';
      // 优先取套票折扣的展示
      if (maxDiscSetValue) {
        return "\u5957\u7968<span style=\"font-family: MaoYanHeiTi-H;margin:0 0.0625rem;\">".concat(maxDiscSetValue, "</span>\u6298\u8D77");
      }
      if (maxDiscSingleValue) {
        return "<span style=\"font-family: MaoYanHeiTi-H;margin-right: 0.0625rem;\">".concat(maxDiscSingleValue, "</span>\u6298\u8D77");
      }
      return '';
    },
    // 计算项目的开演
    timeText: function timeText(content) {
      if (!content) return '';
      var projectStartTime = content.projectStartTime,
        robType = content.robType;
      if (robType !== 3) return '';
      return "\u672C\u5468\u6F14\u51FA";
    },
    // 计算项目的倒计时
    countTime: function countTime(content) {
      if (!content) return 0;
      var saleRemindVO = content.saleRemindVO,
        robType = content.robType;
      if (robType !== 1) return 0;
      var _ref3 = saleRemindVO || {},
        countdownTime = _ref3.countdownTime,
        needCountDown = _ref3.needCountDown,
        onSaleTime = _ref3.onSaleTime;
      var preOneDaySaleTime = onSaleTime - 24 * 60 * 60 * 1000;
      if (countdownTime && preOneDaySaleTime < countdownTime) {
        // 若范特西-倒计时配置不足24h，以范特西配置时间为准
        preOneDaySaleTime = countdownTime;
      }

      /*
      若开售时间未确定或距离开抢>24h，展示“即将开抢”
      若开售时间已确定，距离开抢<=24h，展示“倒计时”，如：“02:10:58后抢“
      */

      var nowTime = Date.now();
      if (needCountDown && nowTime < onSaleTime && preOneDaySaleTime <= nowTime) {
        return onSaleTime;
      }
      return 0;
      // return Date.now() + 23 * 60 * 60 * 1000
    },

    countDownEnd: function countDownEnd(_ref4) {
      var performanceId = _ref4.performanceId,
        type = _ref4.type;
      var index = this[type].findIndex(function (item) {
        return item.performanceId === performanceId;
      });
      if (index > -1) {
        this[type][index].preSale = 0;
      }
    }
  }
};